import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioGroupRootFn = /* @__PURE__ */ createRecipe('radio-group-root', {}, [])

const radioGroupRootVariantMap = {
  "direction": [
    "row"
  ]
}

const radioGroupRootVariantKeys = Object.keys(radioGroupRootVariantMap)

export const radioGroupRoot = /* @__PURE__ */ Object.assign(memo(radioGroupRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioGroupRoot',
  __getCompoundVariantCss__: radioGroupRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioGroupRootVariantKeys,
  variantMap: radioGroupRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioGroupRootVariantKeys)
  },
  getVariantProps: radioGroupRootFn.getVariantProps,
})